import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

function getSessionId() {
  let sid = localStorage.getItem("da_session");
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `s_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("da_session", sid);
  }
  return sid;
}

function send(type, path, meta = "") {
  try {
    api.post("/analytics/event", {
      type,
      path,
      meta,
      referrer: document.referrer || "",
      sessionId: getSessionId(),
    }).catch(() => {});
  } catch (e) {
    /* ignore */
  }
}

// Tracks page views on route change and any WhatsApp link clicks site-wide.
const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    send("pageview", location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (/wa\.link|wa\.me|whatsapp/i.test(href)) {
        send("whatsapp_click", location.pathname, href);
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [location.pathname]);

  return null;
};

export default AnalyticsTracker;
